import React from 'react';

import { useInitDraftSitrepV2 } from 'components/DisasterGPT/hooks/useSitrepsV2';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import type { Incident } from 'components/IAP/hooks/incidentHooks';
import Loader from 'components/Loader/Loader';
import CurrentReportsSitrepCard from 'components/Reports/CurrentReportsSitrepCard';
import type { GetSitrepsResponse } from 'components/Reports/reports.types';
import { buildDraftSitrepPayload } from 'components/Reports/utils/buildDraftSitrepPayload';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

type CurrentReportViewProps = {
  scopeName: string;
  latestSitreps: Map<string, GetSitrepsResponse>;
  isLoading: boolean;
  isError: boolean;
  derivedAorId?: string | null;
  incident?: Incident;
};

const CurrentReportView: React.FC<CurrentReportViewProps> = ({
  scopeName,
  latestSitreps,
  isLoading,
  isError,
  derivedAorId,
  incident,
}) => {
  const initDraftMutation = useInitDraftSitrepV2();

  return (
    <div className="reports-tabs pt-3">
      {isError ? (
        <div className="text-center mt-4">
          <span>Error loading reports.</span>
        </div>
      ) : isLoading ? (
        <Loader />
      ) : latestSitreps.size > 0 ? (
        Array.from(latestSitreps.values()).map((latestSitrep) => (
          <div key={latestSitrep.id} className="reports-tabs__latest-sitrep">
            <CurrentReportsSitrepCard sitrep={latestSitrep} />
          </div>
        ))
      ) : (
        <div className="reports-tabs__header__empty">
          <p>No SITREPs found</p>
          {!derivedAorId ? (
            <div className="text-center mt-4">
              <span>
                Unable to determine Area of Responsibility for this incident.
                Please ensure the incident is associated with an AOR in order to
                create and view draft SITREPs.
              </span>
            </div>
          ) : (
            <StylishNewButton
              className="button--primary"
              type="button"
              onClick={() => {
                initDraftMutation.mutate(
                  buildDraftSitrepPayload({
                    scopeName,
                    aorId: derivedAorId,
                    incidentId: incident?.id,
                  })
                );
              }}
              disabled={isLoading || isError || !derivedAorId}
            >
              <SharedIcon iconName="add" size="md" />
              Create Draft SITREP
            </StylishNewButton>
          )}
        </div>
      )}
    </div>
  );
};

export default CurrentReportView;
